<template>
    <div class="selected">
      <ul>
        <li class="list">
          <span>行业:</span>
          <Select v-model="industry" style="width:100px;" @on-change="change()">
            <Option v-for="(item,index) in industryList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </li>
        <li class="list">
          <span>区:</span>
          <Select v-model="districts" style="width:100px;" @on-change="change()">
            <Option v-for="(item,index) in districtList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </li>
      </ul>
    </div>
</template>

<script>
    export default {
      data(){
        return{
          userConfig: {},
          districts:-1,
          industry:-1,
          districtList:[],
          industryList:[]
        }
      },
      methods:{
        getDistricts(){
          this.$http.get(this.userConfig.apiName + '/v4/districts').then(res=>{
            let result = res.data.data;
            result.push({
              id:-1,
              name:'全部'
            });
            this.$set(this,'districtList',result);
          })
        },
        getIndustry(){
          this.$http.get(this.userConfig.apiName + '/v4/monitorAreaTypes').then(res=>{
            let result = res.data.data;
            result.push({
              id:-1,
              name:'全部'
            });
            this.$set(this,'industryList',result);
          })
        },
        change(){
          this.$root.selectModelHub.$emit("select", this.districts,this.industry);
        }
      },
      mounted(){
        this.$set(this,"userConfig",JSON.parse(window.sessionStorage.getItem("userConfig")));
        if(this.userConfig){
          this.getDistricts();
          this.getIndustry();
        }
      }
    }
</script>

<style scoped lang="less">
.selected {
  position: fixed;
  top: 2.5rem;
  left: 0;
  padding: 10px;
  z-index: 99;
  border-radius: 4px;
  border: 1px solid #06907b;
  background: #081623;

  ul {
    list-style: none;
    padding: 0;

    .list {
      padding: 0.1rem 0;
      span {
        display: inline-block;
        width: 0.4rem;
        color: #0bfcd7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/selectModel.vue